import { Link, useLocation, useNavigate } from 'react-router-dom';
import img1 from '../assets/images/pattern.png'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useAuth } from '../Redux/hooks/useAuth';
import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { SignupRequest, useGetCaptchaQuery, useSignupMutation, useSignupSendCodeMutation, useSignupVerifyMutation } from '../Redux/Apis/authApi';
import { setCredentials } from '../Redux/Slices/authSlice';
import MetaTags from '../Components/MetaTags';
import { toast } from 'react-toastify';

function Signup() {
    const navigate = useNavigate()
    const location = useLocation()
    const auth = useAuth()
    useEffect(() => {
        if (auth.user) {
            // پس از ورود/ثبت‌نام همیشه به داشبورد برو
            navigate('/panel')
        }
    }, [auth.user, navigate])
    const dispatch = useDispatch()
    
    const [signup, { isLoading }] = useSignupMutation()
    const [send_code, {isLoading : isCodeLoading}] = useSignupSendCodeMutation()
    const [verify, { isLoading : isVerifyLoading }] = useSignupVerifyMutation()

    const [refresh, setRefresh ] = useState(1)
    const [errorMsg, setErrorMsg] = useState<any>(false)
    const [type, setType] = useState("first")
    const [refLocked, setRefLocked] = useState(false)

    const { data } = useGetCaptchaQuery({refresh})
    const getCaptcha = () =>  {
        setRefresh((prev) => prev + 1)
    }

    const [formState, setFormState] = useState<SignupRequest>({
        email: '',
        password: '',
        repeatPass: '',
        name: '',
        family: '',
        captcha: '',
        code: '',
        ref_code: undefined,
    })

    // قفل کردن ref_code فقط در صورت وجود در URL
    useEffect(() => {
        const params = new URLSearchParams(location.search)
        const ref = params.get('ref')
        if (ref) {
            setFormState(prev => ({ ...prev, ref_code: ref }))
            setRefLocked(true)
        }
    }, [location.search])

    const handleChange = ({ target: { name, value },} : React.ChangeEvent<HTMLInputElement> ) =>
        setFormState((prev) => ({ ...prev, [name]: value }))

    const checkInput = async (e : any) =>  {
        let error = ""
        const inputs = Array.from(e.target.querySelectorAll('input'))

        await Promise.all(inputs.map((input :any) => {
            switch (input.name) {
                case 'email':
                    if (input.value === "")
                        error = "نام کاربری نباید خالی باشد."
                    break;
                case 'name':
                    if (input.value === "")
                        error = "نام نباید خالی باشد."
                    break;
                case 'family':
                    if (input.value === "")
                        error = "نام خانوادگی نباید خالی باشد."
                    break;
                case 'password':
                    if (input.value.length < 8 || !input.value.match(/((?=.*\d)|(?=.*\W+))(?![.\n])(?=.*[A-Z])(?=.*[a-z]).*$/))
                        error = "رمز عبور می بایست حداقل ۸ کاراکتر و دارای عدد، حروف کوچک و بزرگ باشد"
                    break;
                case 'repeatPass':
                    if (input.value !== formState.password)
                        error = 'رمز وارد شده با تکرار رمز تطابق ندارد'
                    break;
                default:
                    break;
            }
            return input
        }))
        setErrorMsg( error )
        if (error)
            return true

        return false
    }

    const onSubmit = async (e : React.FormEvent) => {
        e.preventDefault()
        try {
            if(type === "first"){
                delete formState.code
                const sent = await send_code(formState).unwrap()
                if (sent){
                    setType("otp")
                    setErrorMsg(false) 
                }else setErrorMsg("خطا در ارسال کداعتبار سنجی")
            }else if(type === "otp"){
                const res = await verify(formState).unwrap()
                if (res){
                    setType("end")
                    setErrorMsg(false) 
                }else {
                    setType("first")
                    setErrorMsg("کد اعتبار سنجی اشتباه وارد شده است!")
                }
            }else if(type === "end"){
                if (await checkInput(e)) return
                const user = await signup(formState).unwrap()
                if(user && user.token){
                    dispatch(setCredentials(user))
                    navigate('/panel')
                    setTimeout(() => {
                        toast.info('ثبت‌نام انجام شد. کد معرف شما در بخش «معرفی به دوستان» پنل در دسترس است.')
                    }, 200)
                }
            }
        } catch (err:any){
            const raw = !err.data ? 'An unexpected error occurred' : Array.isArray(err.data.message) ? err.data.message[0] : err.data.message
            const msg = (raw || '').toString()
            const friendly = /ref|معرف|REFERRAL|INVALID/i.test(msg) ? 'کد معرف نامعتبر است یا قابل استفاده نیست.' : msg
            setErrorMsg(friendly)
            getCaptcha();                                   
        }
    }

    return ( 
        <>
        <MetaTags
            siteName="سایت مرجع آزمون GRE"
            title="ثبت نام آزمون‌ها | سایت مرجع آزمون GRE"
            description="سایت GREhub شبیه ساز حرفه ای آزمون های بین المللی GRE با این هدف راه اندازی شده است که شما داوطلبان گرامی بتوانید سوالات واقعی آزمون GRE، مثل کراون Crown، دالائو Dalao و سایر سوالات اصلی را در محیط شبیه ساز آزمون به صورت آنلاین تمرین کنید، تا مدیریت زمان را به خوبی فراگرفته، و در نتیجه در سنتر و موقع آزمون اصلی بهترین نمره را به راحتی بدست آورید و سپس از دانشگاه های مورد نظرتان به آسانی پذیرش بگیرید."
            url="https://grehub.org/signup"
            image="https://grehub.org/GREhub_LOGO.jpg"
            ogType="website"
            twitterCard="summary_large_image"
        />
        <div className="container-fluid position-relative p-0">
            <div className="row pt-lg-5 g-0">
                <div className="col-lg-6 p-lg-5 mt-lg-5">
                    <div className='p-5'>
                        <h2 className='text-danger'>خوش آمدیــد!</h2>
                        <p>برای ورود به سیستم و استفاده از کلیه امکانات ثبت نام نمایید. </p>
                        {errorMsg && <div className="alert alert-warning" role="alert">
                            {errorMsg}
                        </div>}
                        <form onSubmit={onSubmit}>
                            <div className="row g-2">
                                <div className="col-12 mb-1">
                                    <label htmlFor="email" className="form-label">ایمیل</label>
                                    <input type="email" disabled={type !== 'first'} id='email' name='email' value={formState.email} onChange={handleChange} className="form-control border-0 bg-light px-4" placeholder="آدرس ایمیل خود را وارد نمایید" style={{height: "55px",direction: "rtl"}}/>
                                </div>

                                
                                {type === 'first' && <div className="col-12 input-group mb-3">
                                    <input type="text" name="captcha" value={formState.captcha} id='your_captcha' aria-label="user captcha" aria-describedby="captcha" onChange={handleChange} className="form-control border-0 bg-light px-4" placeholder="کد داخل تصویر" maxLength={4} style={{height: "55px"}}/>
                                    <span className="input-group-text border-0" id="captcha" style={{height: "55px"}}>
                                        <div onClick={getCaptcha} className="text-center" dangerouslySetInnerHTML={{ __html: data?.data! }}></div>
                                    </span>
                                </div>}

                                {/* Referral input when not provided via URL */}
                                {type === 'first' && !refLocked && (
                                    <div className="col-12 mb-3" dir="rtl">
                                        <label htmlFor="ref_code" className="form-label">کد معرف (اختیاری)</label>
                                        <input
                                            type="text"
                                            id="ref_code"
                                            name="ref_code"
                                            value={formState.ref_code ?? ''}
                                            onChange={handleChange}
                                            className="form-control border-0 bg-light px-4"
                                            placeholder="اگر کد معرف دارید اینجا وارد کنید"
                                            style={{height: "55px", direction: 'rtl'}}
                                        />
                                    </div>
                                )}

                                {refLocked && type !== 'otp' && <div className="col-12 mb-3" dir='rtl'>
                                    <div className="alert alert-info py-2">
                                        کد معرف اعمال شد: <strong className='ms-1'>{formState.ref_code}</strong> (غیرقابل ویرایش)
                                    </div>
                                    <input type="hidden" name="ref_code" value={formState.ref_code} readOnly />
                                </div>}

                                {type === "otp" && <div className="col-12 mb-3">
                                    <label htmlFor="code" className="form-label">کد ایمیل شده</label>
                                    <input type="text" value={formState.code} onChange={handleChange} name="code" id='code' aria-describedby='sended-code' className="form-control border-0 bg-light px-4" placeholder="کد ارسالی را وارد نمایید" maxLength={6} style={{height: "55px"}}/>
                                    <div className="form-text text-secondary" id="sended-code"><FontAwesomeIcon className='align-middle me-1' icon="exclamation-circle"/>حتما داخل پوشه اسپم خود را نیز بررسی نمایید.</div>
                                </div>}

                                {type === 'end' && <><div className="col-12 mb-1">
                                    <label htmlFor="namefamily" className="form-label">نام و نام خانوادگی</label>
                                    <div className="input-group" id='namefamily'>
                                        <input type="name" id='name' name='name' value={formState.name} onChange={handleChange} className="form-control border-0 bg-light px-4 " placeholder="نام خود را وارد نمایید" style={{height: "55px",direction: "rtl"}}/>
                                        {/* <span className="input-group-text"></span> */}
                                        <input type="name" id='family' name='family' value={formState.family} onChange={handleChange} className="form-control border-0 bg-light px-4" placeholder="نام خانوادگی خود را وارد نمایید" style={{height: "55px",direction: "rtl"}}/>
                                    </div>
                                </div>
                                <div className="col-12 mb-1">
                                    <label htmlFor="password" className="form-label">رمز عبور</label>
                                    <input type="password" id='password' name='password' value={formState.password} onChange={handleChange} className="form-control border-0 bg-light px-4" placeholder="پسورد خود را وارد نمایید" style={{height: "55px"}}/>
                                </div>
                                <div className="col-12 mb-4">
                                    <label htmlFor="repeatPass" className="form-label">تکرار رمز عبور</label>
                                    <input type="password" id='repeatPass' name='repeatPass' value={formState.repeatPass} onChange={handleChange} className="form-control border-0 bg-light px-4" placeholder="پسورد خود را مجددا وارد نمایید" style={{height: "55px"}}/>
                                </div></>}

                                <div className="col-12">
                                    <input disabled={isLoading || isCodeLoading || isVerifyLoading} className="btn btn-danger w-100 py-3" type="submit" value={type === "end" ? "ثبت نام" : "مرحله بعدی"}/>
                                </div>
                            </div>
                        </form>
                        <p className='text-center mt-5 py-1'>
                        <FontAwesomeIcon icon="user" className='me-1'/>
                        قبلا ثبت نام کردید؟    
                        &nbsp;
                        <Link to="/login" className='text-decoration-underline'>ازینجا وارد شوید</Link>
                        </p>
                    </div>
                </div>
                <div className="col-lg-6 object-fit-fill">
                    <img src={img1} className="img-fluid h-100" style={{objectFit: "cover"}} alt="Signup"/>
                </div>
            </div>
        </div>
        </>
     );
}

export default Signup;
